import { makeStyles } from '@material-ui/core/styles';

import MuiTheme from '../../theme';
import { getThemeStyle, spacingUnits, warning } from '../../theme/theme';

export default makeStyles(
	{
		root: {
			display: 'flex',
			padding: spacingUnits(3),
			position: 'relative',
			marginBottom: spacingUnits(3),
			flexDirection: 'column',

			'&$rootWithSeverityPadding': {
				paddingLeft: spacingUnits(3) + 5,
			},
			'& $severityStripe': {
				position: 'absolute',
				left: 0,
				bottom: 0,
				top: 0,
				width: 8,

				'&$severity-info': {
					backgroundColor: getThemeStyle('palettePrimary300'),
				},
				'&$severity-success': {
					backgroundColor: getThemeStyle('paletteSecondary200'),
				},
				'&$severity-warning': {
					backgroundColor: warning,
				},
				'&$severity-error': {
					backgroundColor: getThemeStyle('paletteErrorMain'),
				},
			},
		},
		rootWithSeverityPadding: {},
		severityStripe: {},
		'severity-info': {},
		'severity-success': {},
		'severity-warning': {},
		'severity-error': {},
		hidden: {},
		[MuiTheme.breakpoints.up('sm')]: {
			root: {
				flexDirection: 'row',
			},
		},
	},
	{ name: 'persistentCard' },
);
